import React from 'react'
import { Button as MuiButton, styled } from '@mui/material'

const StyledButton = styled(MuiButton)(({ theme, color, variant }) => ({
  margin: theme.spacing(0),
  width: '100%',
  boxShadow: 'none',
  textTransform: 'none',
  '&.MuiButton-contained.Mui-disabled': {
    backgroundColor: '#ababab',
    backgroundImage: 'unset',
  },
  '&.MuiButton-outlinedPrimary': {
    '&:hover': {
      backgroundColor: '#5f80eb',
      color: '#fff',
    },
  },
  ...((color === undefined || color === 'primary') &&
    variant !== 'outlined' && {
      backgroundImage: 'linear-gradient(93deg, #638ee4 1%, #6480e4 99%)',
      color: '#fff',
      '&.Mui-disabled': {
        backgroundColor: '#ababab',
        backgroundImage: 'unset',
      },
    }),
}))

export default function Button(props) {
  const {
    text,
    size,
    color,
    variant,
    onClick,
    disabled,
    boldText,
    children,
    ...other
  } = props

  return (
    <StyledButton
      variant={variant || 'contained'}
      size={size || 'large'}
      color={color || 'primary'}
      onClick={onClick}
      disabled={disabled}
      {...other}
    >
      {boldText ? <span className="bold">{text}</span> : text}
      {children}
    </StyledButton>
  )
}
